var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.dialogComponent,{tag:"component",attrs:{"props":_vm.props},on:{"close":(response) => _vm.$emit('close', response)}})
}
var staticRenderFns = []

export { render, staticRenderFns }